import Helper from '@ember/component/helper';
import { type Registry as Services, service } from '@ember/service';
import type { SupportedOverviewDashboardTileIds } from 'lumen/utils/constants/overview-dashboard-constants';

type Positional = [SupportedOverviewDashboardTileIds];

interface IsOverviewDashboardTileVisibleSignature {
  Args: {
    Positional: Positional;
  };
  Return: boolean;
}

export default class IsOdTileVisibleHelper extends Helper<IsOverviewDashboardTileVisibleSignature> {
  @service declare odAccess: Services['od-access'];

  compute(positional: Positional): boolean {
    return this.odAccess.isTileVisible(positional[0]);
  }
}
